export default __webpack_public_path__ + "static/media/angle-thin-left.e66a2c3c.svg";